/* eslint-disable */

export enum FullNameSource {
  /** NONE - The customer has no name yet. */
  NONE = "NONE",
  /** SMS - The name is the display text of this customer's SMS number. */
  SMS = "SMS",
  /** API_CUSTOMER_ID - The name was obtained from the customer ID in the API. */
  API_CUSTOMER_ID = "API_CUSTOMER_ID",
  /** CONTACT - The name was supplied from a customer's contact book. */
  CONTACT = "CONTACT",
  /** TO_OR_CC - The name was obtained from the To or CC field of an email sent to the customer. */
  TO_OR_CC = "TO_OR_CC",
  /** FROM - The name was obtained from the From address of an email sent by the customer. */
  FROM = "FROM",
  /** LEGAL_NAME - The name was entered as the legal name during identity verification. */
  LEGAL_NAME = "LEGAL_NAME",
  /** SETTINGS - The name was entered in web settings, app settings or onboarding. */
  SETTINGS = "SETTINGS",
  /** PII_REMOVAL_REQUEST - The customer requested their PII removed, and so the name is a placeholder. */
  PII_REMOVAL_REQUEST = "PII_REMOVAL_REQUEST",
  /** ONBOARDING - The name was entered in onboarding. */
  ONBOARDING = "ONBOARDING",
}

export interface CustomerFullName {
  full_name?: string;
  full_name_source?: FullNameSource;
}
